import { TabItemType } from '@webclient/components/settings/types';

import BubbleMessageSmileRoundedIcon from '~icons/knowz-iconify/bubble-message-smile-rounded';
import KnowledgeIcon from '~icons/knowz-iconify/cube';
import SearchIcon from '~icons/knowz-iconify/search-smart';
import GeneralIcon from '~icons/knowz-iconify/settings';
import WaveAlt2RoundedIcon from '~icons/knowz-iconify/wave-alt2-rounded';

// In order for routeAliases to work, these must match the tab index
enum SETTINGS_TAB_ENUM {
  GENERAL = 0,
  CONTACT = 1,
  SEARCH = 2,
  VOICE = 4,
  KNOWLEDGE = 3,
  // ACCOUNT = 4,
  // MICROPHONE = 6,
}

export const TAB_ITEMS: TabItemType[] = [
  {
    id: SETTINGS_TAB_ENUM.GENERAL,
    routeAlias: 'general',
    mappedLabel: 'layout.main.sections.header.settings.tabs.general',
    defaultLabel: 'General',
    icon: <GeneralIcon fontSize={20} />,
  },
  {
    id: SETTINGS_TAB_ENUM.CONTACT,
    routeAlias: 'contact', // Used in UserAuthenticationProvider
    mappedLabel: 'layout.main.sections.header.settings.tabs.contact',
    defaultLabel: 'Contact',
    icon: <BubbleMessageSmileRoundedIcon />,
  },
  {
    id: SETTINGS_TAB_ENUM.SEARCH,
    routeAlias: 'search',
    mappedLabel: 'layout.main.sections.header.settings.tabs.search',
    defaultLabel: 'Search',
    icon: <SearchIcon fontSize={20} />,
  },
  {
    id: SETTINGS_TAB_ENUM.VOICE,
    routeAlias: 'voice',
    mappedLabel: 'layout.main.sections.header.settings.tabs.voice',
    defaultLabel: 'Voice',
    icon: <WaveAlt2RoundedIcon fontSize={20} />,
  },
  {
    id: SETTINGS_TAB_ENUM.KNOWLEDGE,
    routeAlias: 'knowledge',
    mappedLabel: 'layout.main.sections.header.settings.tabs.knowledgeBase',
    defaultLabel: 'Knowledge Base',
    icon: <KnowledgeIcon />,
  },
];

const CONFIG = {
  TAB_ITEMS,
};

export default CONFIG;
